import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import useDynamicColors from "../../../../../hooks/useDynamicColors";
import "./style.css";

export const AdultosOnboardingWelcome = () => {
  const colors = useDynamicColors();
  const location = useLocation();
  const navigate = useNavigate();

  const handleButtonClick = () => {
    const currentParams = location.search;
    navigate(`/vxlab-landing-adultos-mobile${currentParams}`);
  };

  const handleButtonAdelante = () => {
    const currentParams = location.search;
    navigate(`/young-onboarding-steppper${currentParams}`);
  };

  return (
    <div className="adultos-onboarding-screen-welcome">
      <div className="adultos-onboarding-2">
        <div className="overlap-group-2">
          {/* <div className="content-wrapper">
            <div className="content-3">
              <div className="text-wrapper-6">9:50</div>

              <img className="img" alt="Icons" src="/img/icons-6.svg" />
            </div>
          </div> */}

          <img
            className="rectangle-2"
            alt="Rectangle"
            src="/img/rectangle.png"
          />

          <img
            className="group"
            alt="Group"
            src="/img/welcome-young-adultos.png"
            style={{width:150, height:150, objectFit:'contain'}}
          />
        </div>

        <p className="pay-for-your-favorit">
          <b>Your account has been opened</b> <br /> <br />
          Enjoy all the benefits of our App
        </p>

        <div className="payment-worldwide">Welcome Soan!</div>
        <div className="test-button-wrapper">
          <div
            className="test-button-2 highlighted-button"
            onClick={handleButtonClick}
          >
            <div className="text-wrapper-5">Let’s start!</div>
          </div>
        </div>
      </div>
    </div>
  );
};
